module.exports = __webpack_public_path__ + "img/image8.ef52c017.png";